/**
 * Prompt K §8.7 — which fuel the sensitivity panel is allowed to flex.
 *
 * The panel flexed "Diesel fuel price (USD/L)" on an OCGT plant, which has no
 * diesel in it: the curve was flat and the axis ran to −$0.10/kWh. One author
 * decides the axis, used by both the panel and the chart.
 */
const GAS_AVAIL = new Set(["pipeline", "virtual_pipeline_lng_cng", "none", "unknown"]);

export const hasSolar = (result) => Number(result?.model?.solar_kw || 0) > 0;

export const fuelAxis = (input, result) => {
  const m = result?.model || {};
  const gasKw = Number(m.gas_kw || 0) + Number(m.ocgt_kw || 0) + Number(m.ccgt_kw || 0);
  const dieselKw = Number(m.genset_kw || 0);
  if (gasKw > dieselKw) {
    const ts = input?.thermal_selection || {};
    const baseline = Number(ts.fuel_gas?.delivered_price_per_gj) || 8;
    return {
      kind: "gas", baseline, min: 2, max: 30, step: 0.5, unit: "$/GJ",
      // a38 — the run's own gas price after server defaults, or null when the
      // patched input would resolve gas availability differently.
      runValue: (res) => {
        const av = String(input?.gas_availability || "").trim().toLowerCase();
        const patchedAv = GAS_AVAIL.has(av) ? av : "pipeline";
        if (res?.gas_availability !== patchedAv) return null;
        const v = res?.model?.thermal_extras?.fuel_gas?.delivered_price_per_gj;
        return typeof v === "number" ? v : null;
      },
      labelKey: "sens.axis.gas_price", legendKey: "sens.chart.legend.gas",
      patch: (inp, v) => ({
        ...inp,
        thermal_selection: {
          ...ts,
          fuel_gas: { ...(ts.fuel_gas || {}), available: true, delivered_price_per_gj: v },
        },
      }),
    };
  }
  const baseline = Number(input?.fuel_price) || 1.15;
  return {
    kind: "diesel", baseline, min: 0.4, max: 3.0, step: 0.05, unit: "$/L",
    runValue: (res) => (typeof res?.inputs_echo?.fuel_price === "number" ? res.inputs_echo.fuel_price : null),
    labelKey: "sens.fuel", legendKey: "sens.chart.legend.fuel",
    patch: (inp, v) => ({ ...inp, fuel_price: v }),
  };
};
